import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const AccountHeadMasterPopup = (props) => {
    return (
        <ModalBasic
            id="accountHeadMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Account head details</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Account head no.</label>
                        <TextInput type='number'
                            id='accHeadNo' name='accHeadNo'
                            value={props.accountHeadObject.accHeadNo}
                            handleChange={(event) => props.handleChange(event, 'accHeadNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Account group:</label>
                        <MultiSelectDropdown
                            drpIdentity="Account group"
                            options={props.accountHeadObject.accGrpList}
                            value={props.accountHeadObject.selectedAccGrp}
                            onChange={(event) =>
                                props.setFilterParameters(event, "selectedAccGrp")
                            }
                        />
                    </div>

                </div>
                <div className='item-grp grid grid-cols-2 gap-2.5 mb-2.5'>
                    <div className='input-grp'>
                        <label>Account head name:</label>
                        <TextInput type='text'
                            id='accHeadName' name='accHeadName'
                            value={props.accountHeadObject.accHeadName}
                            handleChange={(event) => props.handleChange(event, 'accHeadName')}
                            className={props.validState?.error?.accHeadName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Account head description:</label>
                        <TextInput type='text'
                            id='accHeadDesc' name='accHeadDesc'
                            value={props.accountHeadObject.accHeadDesc}
                            handleChange={(event) => props.handleChange(event, 'accHeadDesc')}
                        />
                    </div>

                </div>
                {/* <div className='item-grp grid grid-cols-2 gap-2.5 mb-2.5'>
                    <div className='input-grp'>
                        <label>Opening balance:</label>
                        <TextInput type='text'
                            id='openingBalance' name='openingBalance'
                            value={props.accountHeadObject.openingBalance}
                            handleChange={(event) => props.handleChange(event, 'openingBalance')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Opening date:</label>
                        <TextInput type='date'
                            id='openingDate' name='openingDate'
                            value={props.accountHeadObject.openingDate}
                            handleChange={(event) => props.handleChange(event, 'openingDate')}
                        />
                    </div>
                </div> */}
                <div className='item-grp grid grid-cols-2 gap-2.5 mb-2.5'>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.accountHeadObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} >
                        {props.accountHeadObject.idAccountHead > 0 ?
                            "Update" : "Save"}
                    </button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}